import {
  Card,
  CardHeader,
  Checkbox,
  FormControlLabel,
  useMediaQuery,
  useTheme,
  TablePagination,
} from "@mui/material";
import { useStyles } from "../../../theme/appStyles";
import React, { useEffect, useMemo, useState } from "react";
import {
  CircularProgress,
  Grid,
  Box,
  Button,
  Typography,
  TextField,
  MenuItem,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  useGetProductCategoryQuery,
  useGetProductTagQuery,
  useGetAllMainCategoryQuery,
  useGetSubCategoryByArrayQuery,
  useGetAllPolicyFilterQuery,
  useGetCategoryQuery,
  useGetCustomerQuery,
  useGetProductBrandQuery,
  useGetProductQuery,
  useGetAllCustomerRelationQuery,
} from "../../../Api/attoDeskApi";
import {
  policyCBArray,
  IProductTag,
  ICategory,
  ICustomer,
  IPolicy,
  IProductBrand,
  IProductPopUP2,
  ICustomerRelative2,
} from "../../../Api/Interface/api.interface";
import { useNotifier } from "../../../Core/Notifier";
import { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { CiSearch } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import TableViewIcon from "@mui/icons-material/TableView";
import * as XLSX from "xlsx";
import {
  DataGrid,
  GridColDef,
  GridPagination,
  GridPaginationModel,
  GridRenderCellParams,
  GridRowSelectionModel,
  GridToolbar,
} from "@mui/x-data-grid";
import Autocomplete from "@mui/material/Autocomplete";
import CloseIcon from "@mui/icons-material/Close";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { formatNumber } from "../../../Components/formatNumber/formatNumber";

interface Insured {
  customer: {
    customerFirstName: string;
    customerLastName: string;
  };
}

interface CustomerOption {
  label: string;
  value: number;
}

const allColumns = [
  "Policy No",
  "Type of Coverage",
  "Insurance Company",
  "Product Description",
  "Policy Owner",
  "Insured",
  "Joint Policy Owner",
  "Contingent Policy Owner",
  "Payor",
  "Primary Beneficiaries",
  "Contingent Beneficiaries",
  "Coverage Amount",
  "Premium Details",
  "Premium",
  "Premium Frequency",
  "Draw Day",
  "Issue Date",
  "Expiry Date",
  "Conversion Date",
  "Renewal Date",
  "Paid Up Date",
  "Remark",
];

const stripHtml = (html: string | null | undefined): string => {
  if (!html) return "";
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const getFormattedDate = (createDate: Dayjs | null): string => {
    return createDate ? createDate.format("YYYY-MM-DD") : "";
  };
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 100,
  });
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQuery2, setSearchQuery2] = useState("");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [currentSearchQuery2, setCurrentSearchQuery2] = useState("");

  const [selectedProductBrandId, setSelectedProductBrandId] =
    useState<string>("");
  const [selectedProductCategoryId, setSelectedProductCategoryId] =
    useState<string>("");
  const [selectedProductTagIds, setSelectedProductTagIds] = useState<string[]>(
    []
  );

  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const debouncedSearchQuery2 = useDebounce(searchQuery2, 300);

  const [selectedProductViewOnline, setSelectedProductViewOnline] =
    useState<string>("");
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const startDateAsDate = startDate?.toDate() || null;
  const endDateAsDate = endDate?.toDate() || null;
  const [createDate, setCreateDate] = useState<Dayjs | null>(null);
  const [isPaperVisible, setIsPaperVisible] = useState(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState<string | "">("");
  const [selectedConCustomerId, setSelectedConCustomerId] = useState<
    string | ""
  >("");
  const [selectedJoinCustomerId, setSelectedJoiCustomerId] = useState<
    string | ""
  >("");
  const [selectedpolicyProductId, setSelectedpolicyProductId] = useState<
    string | ""
  >("");
  const [selectedIC, setSelectedIC] = useState<string | "">("");
  const [policyIssueDate, setpolicyIssueDate] = useState<Dayjs | null>(null);
  const [policyExpiryDate, setpolicyExpiryDate] = useState<Dayjs | null>(null);
  const [policyRenewalDate, setpolicyRenewalDate] = useState<Dayjs | null>(
    null
  );
  const [policyPaidUpDate, setpolicyPaidUpDate] = useState<Dayjs | null>(null);
  const [policyCoversionDate, setpolicyCoversionDate] = useState<Dayjs | null>(
    null
  );
  const [expiryDate, setExpiryDate] = useState<string | null>(null);
  const [open, setOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState<string[]>([]);
  const [selectedRowIds, setSelectedRowIds] = useState<GridRowSelectionModel>(
    []
  );

  const handleOpen = () => {
    setSelectedColumns(allColumns);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const { data: categoryData } = useGetAllMainCategoryQuery({
    departmentId: "",
    coursingId: "",
    roleId: null,
    taxeId: "",
    createdDateStart: null,
    createdDateEnd: null,
    searchText: "",
    numberOfLength: 0,
    isActive: true,
    categoryIsLooping: null,
    createdDate: null,
  });

  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
    null
  );
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState<
    number | null
  >(null);

  const [selectedSubToSubCategoryId, setSelectedSubToSubCategoryId] = useState<
    number | null
  >(null);

  const [selectedSubToSubToSubCategoryId, setSelectedSubToSubToSubCategoryId] =
    useState<number | null>(null);

  const { data: subCategoryData, refetch: refetchSubCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedCategoryId ? [Number(selectedCategoryId)] : [],
    });

  const { data: subCategory2Data, refetch: refetchS2bCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedSubCategoryId
        ? [Number(selectedCategoryId), Number(selectedSubCategoryId)]
        : [],
    });

  const { data: subCategory3Data, refetch: refetchS3bCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedSubCategoryId
        ? [
            Number(selectedCategoryId),
            Number(selectedSubCategoryId),
            Number(selectedSubToSubCategoryId),
          ]
        : [],
    });

  const {
    data: relativeData,
    isLoading: relativeIsLoading,
    isError: relativeError,
  } = useGetAllCustomerRelationQuery({
    policyCustomerId: "",
  });

  const categoryList = useMemo(() => {
    return categoryData?.data as ICategory[];
  }, [categoryData?.data]);

  const subCategoryList = useMemo(() => {
    return subCategoryData?.data as ICategory[];
  }, [subCategoryData?.data]);

  const subToSubCategoryList = useMemo(() => {
    return subCategory2Data?.data as ICategory[];
  }, [subCategory2Data?.data]);

  const subToSubToSubCategoryList = useMemo(() => {
    return subCategory3Data?.data as ICategory[];
  }, [subCategory3Data?.data]);

  const relationDataList = useMemo(() => {
    return (relativeData?.data ?? []) as ICustomerRelative2[];
  }, [relativeData?.data]);

  const productCategoryId = selectedSubToSubToSubCategoryId
    ? Number(selectedSubToSubToSubCategoryId)
    : selectedSubToSubCategoryId
    ? Number(selectedSubToSubCategoryId)
    : selectedSubCategoryId
    ? Number(selectedSubCategoryId)
    : selectedCategoryId
    ? Number(selectedCategoryId)
    : String("");

  const { data, isLoading, isError, refetch } = useGetAllPolicyFilterQuery({
    searchText: currentSearchQuery,
    policyCustomerId: selectedCustomerId,
    createdDateStart: startDateAsDate as Date,
    createdDateEnd: endDateAsDate as Date,
    createdDate: getFormattedDate(createDate),
    policyCategoryId: String(productCategoryId),
    policyInsuranceCompanyId: selectedIC,
    policyProductId: selectedpolicyProductId,
    contengentPolicyOwnerId: selectedConCustomerId,
    jointPolicyOwnerId: selectedJoinCustomerId,
    policyIssueDate: getFormattedDate(policyIssueDate),
    policyRenewalDate: policyRenewalDate,
    policyPaidUpDate: policyPaidUpDate,
    policyExpiryDate: policyExpiryDate,
    policyCoversionDate: policyCoversionDate,
    policyIsLifeTimeExpiryDate: expiryDate,

    policyPayor: currentSearchQuery2,
    // policyExpiryDate: "",
    // policyCoversionDate: "",
    // policyRenewalDate: "",
    // policyPaidUpDate: "",
  });

  const { data: productBrandData, isLoading: productBrandLoading } =
    useGetProductBrandQuery({
      searchText: "",
      isActive: true,
    });
  const { data: coursingData, isLoading: coursingLoading } =
    useGetCategoryQuery();
  const { data: taxData, isLoading: taxLoading } = useGetProductTagQuery({
    searchText: "",
    isActive: true,
  });

  const { data: productTagData, isLoading: ProductTagLoading } =
    useGetProductTagQuery({
      searchText: "",
      isActive: true,
    });

  const { data: staffData, isLoading: staffIsLoading } = useGetCustomerQuery({
    searchText: "",
    id: "",
  });

  const {
    data: productData,
    isLoading: productDataIsLoading,
    isError: productDataError,
  } = useGetProductQuery({
    searchText: "",
    id: "",
    productBrandId: null,
    productCategoryId: "",
    productTagIds: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    createdDate: null,
  });

  const { data: customerDate, isLoading: customerIsLoading } =
    useGetCustomerQuery({
      searchText: "",
      id: "",
    });

  const { data: brandListData, isLoading: brandIsLoading } =
    useGetProductBrandQuery({
      searchText: "",
      isActive: true,
    });

  const productBrandList = useMemo(() => {
    return productBrandData?.data as IProductBrand[];
  }, [productBrandData?.data]);

  const coursingList = useMemo(() => {
    return coursingData?.data as ICategory[];
  }, [coursingData?.data]);

  const taxList = useMemo(() => {
    return taxData?.data as IProductTag[];
  }, [taxData?.data]);

  const productList = useMemo(() => {
    return productData?.data as IProductPopUP2[];
  }, [productData?.data]);

  const cliendList = useMemo(() => {
    return (staffData?.data ?? []) as ICustomer[];
  }, [staffData?.data]);

  const customerList = useMemo(() => {
    return customerDate?.data as ICustomer[];
  }, [customerDate?.data]);

  const brandList = useMemo(() => {
    return brandListData?.data as IProductBrand[];
  }, [brandListData?.data]);

  const productBrandMap = useMemo(() => {
    const map = new Map();
    productBrandList?.forEach((brand) => {
      map.set(brand.id, brand.productBrandName);
    });
    return map;
  }, [productBrandList]);

  const taxMap = useMemo(() => {
    const map = new Map();
    taxList?.forEach((tag) => {
      map.set(tag.id, tag.tagName);
    });
    return map;
  }, [taxList]);

  const customerOptions = useMemo(() => {
    if (!Array.isArray(cliendList)) return [];
    return cliendList.map((cust) => ({
      label: `${cust.customerFirstName} ${cust.customerLastName}`,
      value: cust.id,
    }));
  }, [cliendList]);

  const productsOptions = useMemo(() => {
    if (!Array.isArray(productList)) return [];
    return productList.map((cust) => ({
      label: `${cust.productName}`,
      value: cust.id,
    }));
  }, [productList]);

  const iCOptions = useMemo(() => {
    if (!Array.isArray(productBrandList)) return [];
    return productBrandList.map((cust) => ({
      label: `${cust.productBrandName}`,
      value: cust.id,
    }));
  }, [productBrandList]);

  const relativeMap = useMemo(() => {
    const map = new Map();
    relationDataList?.forEach((item) => {
      map.set(item.id, `${toProperCase(item?.related_customer_name)}`);
    });
    return map;
  }, [relationDataList]);

  const relativeCustomerIdMap = useMemo(() => {
    const map = new Map();
    relationDataList?.forEach((item) => {
      map.set(item.id, `${item?.related_customer_id}`);
    });
    return map;
  }, [relationDataList]);

  const expiryOptions: CustomerOption[] = [
    { label: "Yes", value: 1 },
    { label: "No", value: 0 },
  ];

  const brandMap = useMemo(() => {
    const map = new Map();
    brandList?.forEach((category) => {
      map.set(category.id, category.productBrandName);
    });
    return map;
  }, [brandList]);

  const productMap = useMemo(() => {
    const map = new Map();
    productList?.forEach((category) => {
      map.set(category.id, category.productName);
    });
    return map;
  }, [productList]);

  const cutomerMap = useMemo(() => {
    const map = new Map();
    customerList?.forEach((category) => {
      map.set(
        category.id,
        toProperCase(category.customerFirstName || "") +
          " " +
          toProperCase(category.customerLastName || "")
      );
    });
    return map;
  }, [customerList]);

  const coursingMap = useMemo(() => {
    const map = new Map();
    coursingList?.forEach((category) => {
      map.set(category.id, category.categoryName);
    });
    return map;
  }, [coursingList]);

  const handleMainCategoryChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const categoryId = event.target.value as number;
    setSelectedCategoryId(categoryId);
    setSelectedSubCategoryId(null);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);

    const selectedCategory = categoryList.find(
      (category) => category.id == categoryId
    );
  };

  const handleSubCategoryChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const subCategoryId = event.target.value as number;
    setSelectedSubCategoryId(subCategoryId);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);

    const selectedCategory = subCategoryList.find(
      (category) => category.id == subCategoryId
    );
  };

  const handleSubToSubCategoryChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const selectedSubToSubCategoryId = event.target.value as number;
    setSelectedSubToSubCategoryId(selectedSubToSubCategoryId);
    setSelectedSubToSubToSubCategoryId(null);

    const selectedCategory = subToSubCategoryList.find(
      (category) => category.id == selectedSubToSubCategoryId
    );
  };

  const handleSubToSubToSubCategoryChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const selectedSubToSubToSubCategoryId = event.target.value as number;
    setSelectedSubToSubToSubCategoryId(selectedSubToSubToSubCategoryId);

    const selectedCategory = subToSubToSubCategoryList.find(
      (category) => category.id == selectedSubToSubToSubCategoryId
    );
  };

  useEffect(() => {
    if (debouncedSearchQuery.length >= 2 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  useEffect(() => {
    if (debouncedSearchQuery2.length >= 2 || debouncedSearchQuery2 === "") {
      setCurrentSearchQuery2(debouncedSearchQuery2);
      refetch();
    }
  }, [debouncedSearchQuery2]);

  const handleProductBrandChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedValues = event.target.value;
    setSelectedProductBrandId(selectedValues);
  };

  const handleProductViewOnline = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedValues = event.target.value;
    setSelectedProductViewOnline(selectedValues);
  };

  const handleProductCategory = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedValues = event.target.value;
    setSelectedProductCategoryId(selectedValues);
  };

  const handleStartDateChange = (newValue: Dayjs | null) => {
    setStartDate(newValue);
  };

  const handleEndDateChange = (newValue: Dayjs | null) => {
    setEndDate(newValue);
  };

  const handleCreateDateChange = (newValue: Dayjs | null) => {
    setCreateDate(newValue);
  };

  const policyIssueDateDateChange = (newValue: Dayjs | null) => {
    setpolicyIssueDate(newValue);
  };

  const policyExpiryDateDateChange = (newValue: Dayjs | null) => {
    setpolicyExpiryDate(newValue);
  };

  const policyRenewalDateDateChange = (newValue: Dayjs | null) => {
    setpolicyRenewalDate(newValue);
  };

  const policyPaidUpDateDateChange = (newValue: Dayjs | null) => {
    setpolicyPaidUpDate(newValue);
  };

  const policyCoversionDateDateChange = (newValue: Dayjs | null) => {
    setpolicyCoversionDate(newValue);
  };

  const handleProductTag = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = event;
    setSelectedProductTagIds(
      typeof value === "string" ? value.split(",") : value
    );
  };

  useEffect(() => {
    if (debouncedSearchQuery.length >= 2 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleCheckboxChange = (column: string) => {
    setSelectedColumns((prev) =>
      prev.includes(column)
        ? prev.filter((col) => col !== column)
        : [...prev, column]
    );
  };

  const handleSelectAllChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.checked) {
      setSelectedColumns(allColumns);
    } else {
      setSelectedColumns([]);
    }
  };

  const handleRowSelection = (selectionModel: GridRowSelectionModel) => {
    setSelectedRowIds(selectionModel);
  };

  const handleExportSelected12 = () => {
    const selectedRows = formattedRows.filter((row) =>
      selectedRowIds.includes(row.id)
    );

    if (selectedRows.length === 0) {
      alert("Please select at least one row to export!");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(selectedRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Policies");
    const today = dayjs();
    const formattedDate = today.format("MMM, DD YYYY (dddd)");
    const filename = `Policies_Reports_${formattedDate}.xlsx`;
    XLSX.writeFile(workbook, filename);
  };

  const coursings: IPolicy[] = Array.isArray(data?.data)
    ? (data?.data as IPolicy[])
    : [];

  const resetFields = () => {
    setSelectedProductBrandId("");
    setSelectedpolicyProductId("");
    setpolicyIssueDate(null);
    setCreateDate(null);
    setpolicyExpiryDate(null);
    setpolicyRenewalDate(null);
    setpolicyPaidUpDate(null);
    setpolicyCoversionDate(null);
    setSelectedIC("");
    setSelectedpolicyProductId("");
    setSelectedConCustomerId("");
    setSelectedJoiCustomerId("");
    setSelectedCustomerId("");
    setExpiryDate(null);
    setSelectedProductCategoryId("");
    setSelectedProductViewOnline("");
    setSelectedProductTagIds([]);
    setStartDate(null);
    setEndDate(null);
    setSelectedCategoryId(null);
    setSelectedSubCategoryId(null);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);
  };

  const columns = [
    {
      field: "policyNumber",
      headerName: "Policy No",
      width: 250,
      renderCell: (params: GridRenderCellParams) => (
        <Link
          to={`/customer/${params.row.policyCustomerIdInitial}/policy/${params.row.policyNumber}`}
          className={classes.iconLinkPropNormal}
        >
          <span
            style={{
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
            }}
            // onClick={() =>
            //   navigate(
            //     `/customer/${params.row.policyCustomerIdInitial}/policy/${params.row.policyNumber}`
            //   )
            // }
          >
            {params.value}
            {params.value && (
              <FontAwesomeIcon icon={faLink} style={{ color: "#1976d2" }} />
            )}
          </span>
        </Link>
      ),
    },
    { field: "policyCategoryId", headerName: "Type of Coverage", width: 200 },
    {
      field: "policyInsuranceCompanyId",
      headerName: "Insurance Company",
      width: 180,
    },
    { field: "policyProductId", headerName: "Product Description", width: 200 },
    {
      field: "policyCustomerId",
      headerName: "Policy Owner",
      width: 300,

      renderCell: (params: GridRenderCellParams) => (
        <Link
          to={`/profile/customer/${params.row.policyCustomerIdInitial}`}
          className={classes.iconLinkPropNormal}
        >
          <span
            style={{
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
            }}
            // onClick={() =>
            //   navigate(`/profile/customer/${params.row.policyCustomerIdInitial}`)
            // }
          >
            {params.value}
            {params.value && (
              <FontAwesomeIcon icon={faUser} style={{ color: "#1976d2" }} />
            )}
          </span>
        </Link>
      ),
    },
    {
      field: "policyInsuredDetails",
      headerName: "Insured",
      width: 400,
      renderCell: (params: GridRenderCellParams) => {
        const insuredDetails = params.value as Insured[];

        if (!insuredDetails || insuredDetails.length === 0)
          return <span></span>;

        return (
          <span
            style={{
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            {insuredDetails.map((insured: Insured, index: number) => (
              <Link
                key={index}
                to={`/profile/customer/${relativeCustomerIdMap.get(insured)}`}
                className={classes.iconLinkPropNormal}
              >
                <span

                // onClick={(e) => {
                //   e.stopPropagation();
                //   navigate(
                //     `/profile/customer/${relativeCustomerIdMap.get(insured)}`
                //   );
                // }}
                >
                  {relativeMap.get(Number(insured)) || ""}
                  {index < insuredDetails.length - 1 && ", "}
                </span>
              </Link>
            ))}
            {insuredDetails.length > 0 && (
              <FontAwesomeIcon icon={faUser} style={{ color: "#1976d2" }} />
            )}
          </span>
        );
      },
    },
    {
      field: "jointPolicyOwnerId",
      headerName: "Joint Policy Owner",
      width: 300,
      renderCell: (params: GridRenderCellParams) => (
        <Link
          to={`/profile/customer/${params.row.policyCustomerJointPolicyOwnerId}`}
          className={classes.iconLinkPropNormal}
        >
          <span
            style={{
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
            }}
            // onClick={() =>
            //   navigate(
            //     `/profile/customer/${params.row.policyCustomerJointPolicyOwnerId}`
            //   )
            // }
          >
            {params.value}
            {params.value && (
              <FontAwesomeIcon icon={faUser} style={{ color: "#1976d2" }} />
            )}
          </span>
        </Link>
      ),
    },
    {
      field: "contengentPolicyOwnerId",
      headerName: "Contingent Policy Owner",
      width: 300,
      renderCell: (params: GridRenderCellParams) => (
        <Link
          to={`/profile/customer/${params.row.policyCustomerContengentPolicyOwnerId}`}
          className={classes.iconLinkPropNormal}
        >
          <span
            style={{
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
            }}
            // onClick={() =>
            //   navigate(
            //     `/profile/customer/${params.row.policyCustomerContengentPolicyOwnerId}`
            //   )
            // }
          >
            {params.value}
            {params.value && (
              <FontAwesomeIcon icon={faUser} style={{ color: "#1976d2" }} />
            )}
          </span>
        </Link>
      ),
    },
    { field: "policyPayor", headerName: "Payor", width: 150 },
    {
      field: "policyPrimaryBenificariesNew",
      headerName: "Primary Beneficiaries",
      width: 200,
      renderCell: (params: GridRenderCellParams) => {
        const policyPrimaryBenificariesNew = params.value as policyCBArray[];
        return policyPrimaryBenificariesNew.map(
          (insured: policyCBArray, index: number) => (
            <span key={index}>
              {relativeMap.get(Number(insured.column1))}{" "}
              {insured.payoutPercentage ? `- ${insured.payoutPercentage}%` : ""}
              {insured.column2 ? ` (${insured.column2})` : ""}
              {index < policyPrimaryBenificariesNew.length - 1 && ", "}
            </span>
          )
        );
      },
    },
    {
      field: "policyContengentBenificariesNew",
      headerName: "Contingent Beneficiaries",
      width: 200,
      renderCell: (params: GridRenderCellParams) => {
        const policyContengentBenificariesNew = params.value as policyCBArray[];
        return policyContengentBenificariesNew.map(
          (insured: policyCBArray, index: number) => (
            <span key={index}>
              {relativeMap.get(Number(insured.column1))}{" "}
              {insured.payoutPercentage ? `- ${insured.payoutPercentage}%` : ""}
              {index < policyContengentBenificariesNew.length - 1 && ", "}
            </span>
          )
        );
      },
    },
    {
      field: "policyCoverageAmount",
      headerName: "Coverage Amount",
      width: 180,
      renderCell: (params: GridRenderCellParams) => (
        <div>{params.value ? `${formatNumber(params.value)}` : ""}</div>
      ),
    },
    {
      field: "policyPremiumDetails",
      headerName: "Premium Details",
      width: 180,
      renderCell: (params: GridRenderCellParams) => (
        <div>{params.value ? `${formatNumber(params.value)}` : ""}</div>
      ),
    },
    {
      field: "policyPremium",
      headerName: "Premium",
      width: 150,
      renderCell: (params: GridRenderCellParams) => (
        <div>{params.value ? `${formatNumber(params.value)}` : ""}</div>
      ),
    },
    {
      field: "policyPremiumFrequency",
      headerName: "Premium Frequency",
      width: 180,
    },
    { field: "policyDrawDay", headerName: "Draw Day", width: 120 },
    {
      field: "policyIssueDate",
      headerName: "Issue Date",
      width: 150,
      renderCell: (params: GridRenderCellParams) => {
        return params.value ? dayjs(params.value).format("MMM D, YYYY") : "";
      },
    },
    {
      field: "policyExpiryDate",
      headerName: "Expiry Date",
      width: 250,
      renderCell: (params: GridRenderCellParams) => {
        const { date, isLifetime } = params.value || {};
        return (
          <span>
            {isLifetime
              ? "Death"
              : date
              ? dayjs(date).format("MMM D, YYYY")
              : ""}
          </span>
        );
      },
    },
    {
      field: "policyCoversionDate",
      headerName: "Conversion Date",
      width: 150,
      renderCell: (params: GridRenderCellParams) => {
        return params.value ? dayjs(params.value).format("MMM D, YYYY") : "";
      },
    },
    {
      field: "policyRenewalDate",
      headerName: "Renewal Date",
      width: 150,
      renderCell: (params: GridRenderCellParams) => {
        return params.value ? dayjs(params.value).format("MMM D, YYYY") : "";
      },
    },
    {
      field: "policyPaidUpDate",
      headerName: "Paid Up Date",
      width: 150,
      renderCell: (params: GridRenderCellParams) => {
        return params.value ? dayjs(params.value).format("MMM D, YYYY") : "";
      },
    },
    {
      field: "policyRemark",
      headerName: "Remark",
      miniwidth: 700,
      renderCell: (params: GridRenderCellParams) => (
        <div>{stripHtml(params.value) || ""}</div>
      ),
    },
  ];

  const formattedRows = coursings.map((row) => ({
    id: row.id,
    policyNumber: row.policyNumber,
    policyCategoryId: coursingMap.get(Number(row.policyCategoryId)) || "",
    policyInsuranceCompanyId:
      brandMap.get(Number(row.policyInsuranceCompanyId)) || "",
    policyProductId: productMap.get(Number(row.policyProductId)) || "",
    policyCustomerId: cutomerMap.get(Number(row.policyCustomerId)) || "",
    jointPolicyOwnerId: relativeMap.get(Number(row.jointPolicyOwnerId)) || "",
    contengentPolicyOwnerId:
      relativeMap.get(Number(row.contengentPolicyOwnerId)) || "",
    policyInsuredDetails: row.policyInsuredDetails,
    policyPayor: toProperCase(row.policyPayor),
    policyPrimaryBenificariesNew: row.policyPrimaryBenificariesNew,
    policyContengentBenificariesNew: row.policyContengentBenificariesNew,
    policyCoverageAmount: row.policyCoverageAmount,
    policyPremiumDetails: row.policyPremiumDetails,
    policyPremium: row.policyPremium,
    policyPremiumFrequency: row.policyPremiumFrequency,
    policyDrawDay: row.policyDrawDay,
    policyIssueDate: row.policyIssueDate,
    policyExpiryDate: {
      date: row.policyExpiryDate,
      isLifetime: row.policyIsLifeTimeExpiryDate,
    },
    policyCoversionDate: row.policyCoversionDate,
    policyRenewalDate: row.policyRenewalDate,
    policyPaidUpDate: row.policyPaidUpDate,
    policyRemark: row.policyRemark,
    policyCustomerIdInitial: row.policyCustomerId,
    policyCustomerJointPolicyOwnerId: relativeCustomerIdMap.get(
      row.jointPolicyOwnerId
    ),
    policyCustomerContengentPolicyOwnerId: relativeCustomerIdMap.get(
      row.contengentPolicyOwnerId
    ),
  }));

  const handleToggle = () => {
    setIsPaperVisible(!isPaperVisible);
  };

  const handleExport = () => {
    handleExportExcel(selectedColumns);
    handleClose();
  };

  const handleExportExcel = (selectedCols: string[]) => {
    const coursings: IPolicy[] = Array.isArray(data?.data)
      ? (data?.data as IPolicy[])
      : [];
    const selectedRows = coursings.filter((row) =>
      selectedRowIds.includes(row.id)
    );

    if (selectedRows.length === 0) {
      alert("Please select at least one row to export!");
      return;
    }
    const fullExcelData = selectedRows.map((row) => ({
      "Policy No": row.policyNumber,
      "Type of Coverage": coursingMap.get(Number(row.policyCategoryId)) || "",
      "Insurance Company":
        brandMap.get(Number(row.policyInsuranceCompanyId)) || "",
      "Product Description": productMap.get(Number(row.policyProductId)) || "",
      "Policy Owner": cutomerMap.get(Number(row.policyCustomerId)) || "",
      Insured: (row.policyInsuredDetails || [])
        .map((insuredId) => relativeMap.get(Number(insuredId)) || "")
        .join(", "),
      "Joint Policy Owner":
        relativeMap.get(Number(row.jointPolicyOwnerId)) || "",
      "Contingent Policy Owner":
        relativeMap.get(Number(row.contengentPolicyOwnerId)) || "",
      Payor: toProperCase(row.policyPayor),
      "Primary Beneficiaries": row.policyPrimaryBenificariesNew
        .map((insured) => {
          const name = relativeMap.get(Number(insured.column1)) || "";
          const payout = insured.payoutPercentage
            ? ` - ${insured.payoutPercentage}%`
            : "";
          const type = insured.column2 ? ` (${insured.column2})` : "";
          return `${name}${payout}${type}`;
        })
        .join(", "),
      "Contingent Beneficiaries": row.policyContengentBenificariesNew
        .map((insured) => {
          const name = relativeMap.get(Number(insured.column1)) || "";
          const payout = insured.payoutPercentage
            ? ` - ${insured.payoutPercentage}%`
            : "";
          return `${name}${payout}`;
        })
        .join(", "),
      "Coverage Amount": formatNumber(row.policyCoverageAmount),
      "Premium Details": formatNumber(row.policyPremiumDetails),
      Premium: formatNumber(row.policyPremium),
      "Premium Frequency": row.policyPremiumFrequency,
      "Draw Day": row.policyDrawDay,
      "Issue Date": row.policyIssueDate
        ? dayjs(row.policyIssueDate).format("MMM D, YYYY")
        : "",
      "Expiry Date": row.policyIsLifeTimeExpiryDate
        ? "Death"
        : row.policyExpiryDate
        ? dayjs(row.policyExpiryDate).format("MMM D, YYYY")
        : "",
      "Conversion Date": row.policyCoversionDate
        ? dayjs(row.policyCoversionDate).format("MMM D, YYYY")
        : "",
      "Renewal Date": row.policyRenewalDate
        ? dayjs(row.policyRenewalDate).format("MMM D, YYYY")
        : "",
      "Paid Up Date": row.policyPaidUpDate
        ? dayjs(row.policyPaidUpDate).format("MMM D, YYYY")
        : "",
      Remark: stripHtml(row.policyRemark),
    }));

    const filteredExcelData = fullExcelData.map((row) => {
      const filteredRow: any = {};
      selectedCols.forEach((col) => {
        filteredRow[col] = row[col as keyof typeof row];
      });
      return filteredRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(filteredExcelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Policies_Report");
    const today = dayjs();
    const formattedDate = today.format("MMM, DD YYYY (dddd)");
    const filename = `Policies_Reports_${formattedDate}.xlsx`;
    XLSX.writeFile(workbook, filename);
  };

  const isAllSelected = selectedColumns.length === allColumns.length;

  const handleChangePage = (event: unknown, newPage: number) => {
    setPaginationModel((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = parseInt(event.target.value, 10);
    setPaginationModel({ page: 0, pageSize: value });
  };

  if (
    isLoading ||
    productBrandLoading ||
    coursingLoading ||
    taxLoading ||
    ProductTagLoading
  ) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Card className={classes.card}>
      <Grid
        container
        justifyContent={"space-between"}
        spacing={5}
        sx={{ borderBottom: 2, padding: 2 }}
        className={classes.titleGrid}
      >
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Grid
            container
            spacing={1}
            justifyContent="flex-end"
            sx={{ display: "flex" }}
          >
            <Grid item lg={3} md={3} sm={12} xs={12}>
              <Autocomplete
                options={customerOptions}
                loading={staffIsLoading}
                getOptionLabel={(option: CustomerOption) => option.label}
                onChange={(event, newValue: CustomerOption | null) => {
                  setSelectedCustomerId(String(newValue?.value ?? ""));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    InputLabelProps={{ shrink: true }}
                    placeholder="Policy Owner name .."
                  />
                )}
                sx={{ flexGrow: 1, width: "100%" }}
                size="small"
                className={classes.searchTextField}
              />
            </Grid>
            <Grid item>
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CiSearch className={classes.searchWidgetIcon} />
                    </InputAdornment>
                  ),
                  classes: {
                    root: classes.formControlList,
                  },
                }}
                fullWidth
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Policy Number .."
                sx={{ width: "100%" }}
                size="small"
                className={classes.searchTextField}
              />
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                className={classes.addButton}
                onClick={handleToggle}
              >
                {isPaperVisible ? "Close Filter" : "Open Filter"}
              </Button>
            </Grid>
            <Grid item>
              <Button
                // variant="contained"
                startIcon={<TableViewIcon />}
                className={classes.addNewButton}
                onClick={handleOpen}
                disabled={selectedRowIds.length === 0}
              >
                Export to Excel
              </Button>
            </Grid>
            {/* <Grid item>
              <Button
                // variant="contained"
                startIcon={<TableViewIcon />}
                className={classes.addNewButton}
                onClick={handleExportSelected12}
              >
                Export to Excel hh
              </Button>
            </Grid> */}
          </Grid>
        </Grid>
      </Grid>

      {isPaperVisible && (
        <>
          <Grid container spacing={3} my={5} p={4}>
            <Grid item lg={3} md={4} sm={12} xs={12}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle1" className={classes.body2}>
                    Insurance Company
                  </Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Autocomplete
                    options={iCOptions}
                    loading={productBrandLoading}
                    value={
                      iCOptions.find(
                        (option) =>
                          String(option.value) === selectedpolicyProductId
                      ) || null
                    }
                    disableCloseOnSelect
                    getOptionLabel={(option: CustomerOption) => option.label}
                    onChange={(event, newValue: CustomerOption | null) => {
                      setSelectedIC(String(newValue?.value ?? ""));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        InputLabelProps={{ shrink: true }}
                        placeholder="Insurance Company .."
                      />
                    )}
                    sx={{ flexGrow: 1, width: "100%" }}
                    size="small"
                    className={classes.searchTextField}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={3} md={4} sm={12} xs={12}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle1" className={classes.body2}>
                    Main Coverage
                  </Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    className={classes.searchTextField}
                    value={selectedCategoryId || ""}
                    onChange={handleMainCategoryChange}
                    InputLabelProps={{ shrink: true }}
                  >
                    <MenuItem value="" disabled style={{ color: "gray" }}>
                      Select an option
                    </MenuItem>
                    {categoryList &&
                      categoryList.map((category) => (
                        <MenuItem key={category.id} value={category.id}>
                          {category.categoryName}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
              </Grid>
            </Grid>
            {selectedCategoryId && subCategoryList.length > 0 && (
              <Grid item lg={3} md={4} sm={12} xs={12}>
                <Grid container>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography variant="subtitle1" className={classes.body2}>
                      Sub Coverage
                    </Typography>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      className={classes.searchTextField}
                      value={
                        selectedSubCategoryId === null
                          ? ""
                          : selectedSubCategoryId
                      }
                      onChange={handleSubCategoryChange}
                      InputLabelProps={{ shrink: true }}
                    >
                      <MenuItem value="" disabled style={{ color: "gray" }}>
                        Select an option
                      </MenuItem>
                      {subCategoryList.map((subcategory) => (
                        <MenuItem key={subcategory.id} value={subcategory.id}>
                          {subcategory.categoryName}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>
              </Grid>
            )}
            {selectedCategoryId &&
              selectedSubCategoryId &&
              subToSubCategoryList.length > 0 && (
                <Grid item lg={3} md={4} sm={12} xs={12}>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography variant="subtitle1" className={classes.body2}>
                        Sub-to-Sub Coverage
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextField
                        select
                        fullWidth
                        size="small"
                        className={classes.searchTextField}
                        value={
                          selectedSubToSubCategoryId === null
                            ? ""
                            : selectedSubToSubCategoryId
                        }
                        onChange={handleSubToSubCategoryChange}
                        InputLabelProps={{ shrink: true }}
                      >
                        <MenuItem value="" disabled style={{ color: "gray" }}>
                          Select an option
                        </MenuItem>
                        {subToSubCategoryList.map((subToSubcategory) => (
                          <MenuItem
                            key={subToSubcategory.id}
                            value={subToSubcategory.id}
                          >
                            {subToSubcategory.categoryName}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            {selectedCategoryId &&
              selectedSubCategoryId &&
              selectedSubToSubCategoryId &&
              subToSubToSubCategoryList.length > 0 && (
                <Grid item lg={3} md={4} sm={12} xs={12}>
                  <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography variant="subtitle1" className={classes.body2}>
                        Sub-to-Sub-to-Sub Coverage
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <TextField
                        select
                        fullWidth
                        size="small"
                        className={classes.searchTextField}
                        value={
                          selectedSubToSubToSubCategoryId === null
                            ? ""
                            : selectedSubToSubToSubCategoryId
                        }
                        onChange={handleSubToSubToSubCategoryChange}
                        InputLabelProps={{ shrink: true }}
                      >
                        <MenuItem value="" disabled style={{ color: "gray" }}>
                          Select an option
                        </MenuItem>
                        {subToSubToSubCategoryList.map(
                          (subToSubToSubcategory) => (
                            <MenuItem
                              key={subToSubToSubcategory.id}
                              value={subToSubToSubcategory.id}
                            >
                              {subToSubToSubcategory.categoryName}
                            </MenuItem>
                          )
                        )}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
              )}

            <Grid item lg={3} md={4} sm={12} xs={12}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle1" className={classes.body2}>
                    Products
                  </Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Autocomplete
                    options={productsOptions}
                    loading={productDataIsLoading}
                    value={
                      productsOptions.find(
                        (option) =>
                          String(option.value) === selectedpolicyProductId
                      ) || null
                    }
                    getOptionLabel={(option: CustomerOption) => option.label}
                    onChange={(event, newValue: CustomerOption | null) => {
                      setSelectedpolicyProductId(String(newValue?.value ?? ""));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        InputLabelProps={{ shrink: true }}
                        placeholder="Products .."
                      />
                    )}
                    sx={{ flexGrow: 1, width: "100%" }}
                    size="small"
                    className={classes.searchTextField}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item lg={3} md={4} sm={12} xs={12}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle1" className={classes.body2}>
                    Con Policy Owner
                  </Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Autocomplete
                    options={customerOptions}
                    loading={staffIsLoading}
                    value={
                      customerOptions.find(
                        (option) =>
                          String(option.value) === selectedConCustomerId
                      ) || null
                    }
                    getOptionLabel={(option: CustomerOption) => option.label}
                    onChange={(event, newValue: CustomerOption | null) => {
                      setSelectedConCustomerId(String(newValue?.value ?? ""));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        InputLabelProps={{ shrink: true }}
                        placeholder="Contengent Policy Owner .."
                      />
                    )}
                    sx={{ flexGrow: 1, width: "100%" }}
                    size="small"
                    className={classes.searchTextField}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item lg={3} md={4} sm={12} xs={12}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle1" className={classes.body2}>
                    Joint Policy Owner
                  </Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Autocomplete
                    options={customerOptions}
                    loading={staffIsLoading}
                    value={
                      customerOptions.find(
                        (option) =>
                          String(option.value) === selectedJoinCustomerId
                      ) || null
                    }
                    getOptionLabel={(option: CustomerOption) => option.label}
                    onChange={(event, newValue: CustomerOption | null) => {
                      setSelectedJoiCustomerId(String(newValue?.value ?? ""));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        InputLabelProps={{ shrink: true }}
                        placeholder="Joint Policy Owner .."
                      />
                    )}
                    sx={{ flexGrow: 1, width: "100%" }}
                    size="small"
                    className={classes.searchTextField}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item lg={3} md={4} sm={12} xs={12}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle1" className={classes.body2}>
                    Issue Date
                  </Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      onChange={policyIssueDateDateChange}
                      value={policyIssueDate}
                      slotProps={{
                        textField: {
                          size: "small",
                          sx: { width: "100%" },
                          InputProps: {
                            sx: { fontSize: 14 },
                          },
                          InputLabelProps: {
                            sx: { fontSize: 14 },
                          },
                        },
                      }}
                      className={classes.searchTextField}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </Grid>

            <Grid item lg={3} md={4} sm={12} xs={12}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle1" className={classes.body2}>
                    Death
                  </Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Autocomplete
                    options={expiryOptions}
                    loading={staffIsLoading}
                    value={
                      expiryOptions.find(
                        (option) => String(option.value) === expiryDate
                      ) || null
                    }
                    getOptionLabel={(option: CustomerOption) => option.label}
                    onChange={(event, newValue: CustomerOption | null) => {
                      setExpiryDate(String(newValue?.value ?? ""));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        InputLabelProps={{ shrink: true }}
                        placeholder="Death .."
                      />
                    )}
                    sx={{ flexGrow: 1, width: "100%" }}
                    size="small"
                    className={classes.searchTextField}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item lg={3} md={4} sm={12} xs={12}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle1" className={classes.body2}>
                    Expiry Date
                  </Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      onChange={policyExpiryDateDateChange}
                      value={policyExpiryDate}
                      slotProps={{
                        textField: {
                          size: "small",
                          sx: { width: "100%" },
                          InputProps: {
                            sx: { fontSize: 14 },
                          },
                          InputLabelProps: {
                            sx: { fontSize: 14 },
                          },
                        },
                      }}
                      className={classes.searchTextField}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </Grid>

            <Grid item lg={3} md={4} sm={12} xs={12}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle1" className={classes.body2}>
                    Conversion Date
                  </Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      onChange={policyCoversionDateDateChange}
                      value={policyCoversionDate}
                      slotProps={{
                        textField: {
                          size: "small",
                          sx: { width: "100%" },
                          InputProps: {
                            sx: { fontSize: 14 },
                          },
                          InputLabelProps: {
                            sx: { fontSize: 14 },
                          },
                        },
                      }}
                      className={classes.searchTextField}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </Grid>

            <Grid item lg={3} md={4} sm={12} xs={12}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle1" className={classes.body2}>
                    Renewal Date
                  </Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      onChange={policyRenewalDateDateChange}
                      value={policyRenewalDate}
                      slotProps={{
                        textField: {
                          size: "small",
                          sx: { width: "100%" },
                          InputProps: {
                            sx: { fontSize: 14 },
                          },
                          InputLabelProps: {
                            sx: { fontSize: 14 },
                          },
                        },
                      }}
                      className={classes.searchTextField}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </Grid>

            <Grid item lg={3} md={4} sm={12} xs={12}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle1" className={classes.body2}>
                    Paid Up Date
                  </Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      onChange={policyPaidUpDateDateChange}
                      value={policyPaidUpDate}
                      slotProps={{
                        textField: {
                          size: "small",
                          sx: { width: "100%" },
                          InputProps: {
                            sx: { fontSize: 14 },
                          },
                          InputLabelProps: {
                            sx: { fontSize: 14 },
                          },
                        },
                      }}
                      className={classes.searchTextField}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </Grid>

            <Grid item lg={3} md={4} sm={12} xs={12}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle1" className={classes.body2}>
                    Create Date
                  </Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      onChange={handleCreateDateChange}
                      value={createDate}
                      slotProps={{
                        textField: {
                          size: "small",
                          sx: { width: "100%" },
                          InputProps: {
                            sx: { fontSize: 14 },
                          },
                          InputLabelProps: {
                            sx: { fontSize: 14 },
                          },
                        },
                      }}
                      className={classes.searchTextField}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle1" className={classes.body2}>
                    Payor / Premium / Coverage Amount
                  </Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <TextField
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <CiSearch className={classes.searchWidgetIcon} />
                        </InputAdornment>
                      ),
                      classes: {
                        root: classes.formControlList,
                      },
                    }}
                    fullWidth
                    value={searchQuery2}
                    onChange={(e) => setSearchQuery2(e.target.value)}
                    placeholder=" Payor / Premium / Coverage Amount .."
                    sx={{ width: "100%" }}
                    size="small"
                    className={classes.searchTextField}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* <Grid item lg={2} md={3} sm={12} xs={12}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle1" className={classes.body2}>
                    Start Date
                  </Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      onChange={handleStartDateChange}
                      value={startDate}
                      slotProps={{
                        textField: {
                          size: "small",
                          sx: { width: "100%" },
                          InputProps: {
                            sx: { fontSize: 14 },
                          },
                          InputLabelProps: {
                            sx: { fontSize: 14 },
                          },
                        },
                      }}
                      className={classes.searchTextField}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={2} md={3} sm={12} xs={12}>
              <Grid container>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="subtitle1" className={classes.body2}>
                    End Date
                  </Typography>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      onChange={handleEndDateChange}
                      value={endDate}
                      slotProps={{
                        textField: {
                          size: "small",
                          sx: { width: "100%" },
                          InputProps: {
                            sx: { fontSize: 14 },
                          },
                          InputLabelProps: {
                            sx: { fontSize: 14 },
                          },
                        },
                      }}
                      className={classes.searchTextField}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </Grid> */}
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Box display="flex" justifyContent="flex-end">
                <Button
                  variant="outlined"
                  startIcon={<RestartAltIcon />}
                  className={classes.addButton}
                  onClick={resetFields}
                >
                  Reset
                </Button>
              </Box>
            </Grid>
          </Grid>
        </>
      )}

      <Grid>
        <Grid
          item
          sx={{ width: "100%", pb: 5, borderTop: 2, pt: 3 }}
          className={classes.titleGrid}
        >
          <div style={{ width: "100%" }}>
            <TablePagination
              component="div"
              count={formattedRows.length}
              page={paginationModel.page}
              onPageChange={handleChangePage}
              rowsPerPage={paginationModel.pageSize}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 20, 50, 100, formattedRows.length]}
            />

            <DataGrid
             rows={formattedRows.slice(
              paginationModel.page * paginationModel.pageSize,
              (paginationModel.page + 1) * paginationModel.pageSize
            )}
              columns={columns}
              getRowId={(row) => row.id}
              autoHeight
              rowHeight={60}
              checkboxSelection
              disableRowSelectionOnClick
              className={classes.dataGridTable}
              onRowSelectionModelChange={handleRowSelection}
              hideFooter // <-- hide pagination/footer completely
            />
          </div>
          {/* <DataGrid
            rows={formattedRows}
            columns={columns}
            getRowId={(row) => row.id}
            autoHeight
            pagination
            initialState={{
              pagination: { paginationModel: { pageSize: 100 } },
            }}
            pageSizeOptions={[5, 10, 20, 50, 100]}
            style={{ height: "100%", width: "100%" }}
            className={classes.dataGridTable}
            rowHeight={60}
            checkboxSelection
            disableRowSelectionOnClick
            onRowSelectionModelChange={handleRowSelection}
          /> */}
        </Grid>
      </Grid>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-describedby="alert-dialog-description"
        classes={{ paper: "inherit" }}
        fullScreen={isMobile}
        fullWidth={isMobile}
        maxWidth="lg"
      >
        <Grid className={classes.Dialog}>
          <Grid container spacing={3}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={3}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                          Select Columns to Export
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={3} p={"24px"}>
                      <Grid container spacing={3} p={"24px"}>
                        <>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={isAllSelected}
                                  indeterminate={
                                    selectedColumns.length > 0 && !isAllSelected
                                  }
                                  onChange={handleSelectAllChange}
                                />
                              }
                              label="Select All"
                            />
                          </Grid>

                          {allColumns.map((column) => (
                            <Grid
                              item
                              lg={3}
                              md={3}
                              sm={12}
                              xs={12}
                              key={column}
                            >
                              <FormControlLabel
                                key={column}
                                control={
                                  <Checkbox
                                    checked={selectedColumns.includes(column)}
                                    onChange={() =>
                                      handleCheckboxChange(column)
                                    }
                                  />
                                }
                                label={column}
                              />
                            </Grid>
                          ))}
                        </>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.card}>
                    <Grid container spacing={3} p={"24px"}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          variant="outlined"
                          startIcon={<CloseIcon />}
                          className={classes.addButton}
                          onClick={handleClose}
                        >
                          Cancel
                        </Button>
                        <Box m={0.5}></Box>

                        <Button
                          variant="contained"
                          startIcon={<TableViewIcon />}
                          className={classes.addButton}
                          onClick={handleExport}
                          disabled={selectedColumns.length === 0}
                        >
                          Export
                        </Button>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    </Card>
  );
};

export default Index;
